module.exports = __webpack_public_path__ + "img/addEnclosureWhite.98e84d3b.svg";